import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierDriverService,
  CarrierModel,
  DriverManualAddRequest,
  CarrierDriverModel,
  AnyValueModelUUID,
  DriverProfileRequest,
  DriverAddRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierDriverApiService {
  constructor(private apiService: CarrierDriverService) {}

  public addDriver(carrierId: string, operationId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.carrierDriverAdd(carrierId, operationId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addDriverManual(carrierId: string, body: DriverManualAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.carrierDriverAddManual(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteDriver(driverId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierDriverDelete(driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverAddress(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierDriverModel> {
    return this.apiService.carrierDriverEditAddress(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverLicense(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverEditDriverLicense(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverIacssp(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverEditIacssp(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverLegalDocument(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverEditLegal(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverProfile(driverId: string, body: DriverProfileRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierDriverModel> {
    return this.apiService.carrierDriverEditProfile(driverId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverTwicBack(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverEditTwicBack(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierDriverTwicFront(driverId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverEditTwicFront(driverId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public driver(driverId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierDriverModel> {
    return this.apiService.carrierDriverGet(driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public inviteDriver(carrierId: string, value: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierDriverInvite(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public parseDriverLicense(carrierId: string, body: DriverAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierDriverParseLicense(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
